<template>
  <div>
    <NavTop class="navbar">
    </Navtop>
    <!-- 内容 -->
    <div class="box content">
      <div class="box_l">
        <div class="box_l_t">
          <p>加入我们</p>
          <p>ABOUT CUEB</p>
        </div>
        <div class="box_r_t">
          <ul class="box_r_ul">
            <li class="box_r_li">
              <span>加入我们</span>
            </li>
          </ul>
        </div>
      </div>
      <div class="box_r">
        <div class="box_r_t">
          <div class="box_r_t_l">加入我们</div>
          <div class="box_r_t_r">首页/加入我们</div>
        </div>
        <div class="box_r_b">
          <aside>
            <img src="../../assets/images/ding.png" alt>
            <ul>
              <li>
                <h2>学校地址</h2>
                ：
                <p>河北省廊坊市经济开发区东方大学城</p>
              </li>
            </ul>
          </aside>
          <aside>
            <img src="../../assets/images/youx.png" alt>
            <ul>
              <li>
                <h2>邮编</h2>：
                <p>065001</p>
              </li>
              <li>
                <h2>电子邮箱</h2>：
                <p>oitoffice@126.com</p>
              </li>
            </ul>
          </aside>
          <aside>
            <img src="../../assets/images/phone.png" alt>
            <ul>
              <li>
                <h2>招生办公室</h2>：
                <p>0316-2901888<br>0316-2901877</p>
              </li>
            </ul>
          </aside>
          <aside>
            <img src="../../assets/images/phone.png" alt>
            <ul>
              <li>
                <h2>学生服务中心</h2>：
                <p>0316-2901683</p>
              </li>
            </ul>
          </aside>
          <aside>
            <img src="../../assets/images/dizhi.png" alt>
            <ul>
              <li>
                <h2>校办公室</h2>：
                <p>0316-290186&emsp;&emsp;<span>一号楼208</span>&emsp;&emsp;日常事务</p>
              </li>
              <li>
                <h2>就业办公室</h2>：
                <p>0316-2901879&emsp;&emsp;<span>北校区第五教学楼452</span>&emsp;&emsp;学生就业</p>
              </li>
            </ul>
          </aside>
          <aside>
            <img src="../../assets/images/qqq.png" alt>
            <ul>
              <li>
                <h2>2022新生官方QQ群</h2>：
                <p>17150809 招生咨询</p>
              </li>
            </ul>
          </aside>
          <div class="box_r_b">
            <Map></Map>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import Map from '../../components/Map/Map.vue'

export default {
  components: {Map},
  data () {
    return {}
  },
  mounted () {

  },
  methods: {}
}
</script>
<style lang="less" scoped>
.box {
  padding-bottom: 40px;
  display: flex;
  justify-content: space-between;

  .box_l {
    width: 195px;
    height: 525px;
    background: url(../../assets/images/list.png);
    background-size: 100% 100%;
    position: relative;
    z-index: 99;

    .box_l_t {
      p {
        &:nth-child(1) {
          font-size: 30px;
          font-weight: bold;
          color: #fff;
          text-align: center;
          margin: 20px;
        }

        &:nth-child(2) {
          font-size: 14px;
          color: #fff;
          text-align: center;
          line-height: 36px;
        }
      }
    }

    .box_r_t {
      width: 195px;
      margin-top: 90px;

      .box_r_ul {
        width: 100%;

        .box_r_li {
          width: 100%;
          height: 30px;
          text-align: center;
          line-height: 30px;

          span {
            display: block;
            color: #666;
            font-size: 15px;
            cursor: pointer;

            &:hover {
              color: #B5070E;
            }
          }
        }
      }
    }
  }

  .box_r {
    width: 960px;

    .box_r_t {
      height: 45px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      border-bottom: 1px solid #eee;

      .box_r_t_l {
        padding: 0 15px;
        line-height: 45px;
        font-size: 20px;
        font-weight: bold;
        color: #444;
        border-bottom: 2px solid #9e070e;
      }

      .box_r_t_r {
        font-size: 14px;
        color: #666;
        cursor: pointer;
      }
    }

    .box_r_b {
      padding: 20px 0;

      aside {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        border-bottom: 1px dashed #c4c4c4;

        img {
          width: 38px;
          margin: 0 25px;
        }

        ul {
          margin-left: 10px;
          padding: 20px 0;

          li {
            line-height: 30px;
            display: flex;
            justify-content: flex-start;
            color: #666;

            h2 {
              min-width: 98px;
              line-height: 30px;
              font-weight: normal;
              text-align-last: justify;
              text-align: justify;
              font-size: 16px;
            }

            p {
              width: 510px;
              text-align: left;
              line-height: 30px;
            }
          }
        }
      }

      .box_r_b {
        width: 960px;
        height: 600px;
        padding: 20px 0;
        display: flex;
        justify-content: center;
      }
    }
  }
}

ul, li, ol {
  list-style: none;
}

.content {
  width: 1200px;
  margin: 0 auto;
}
</style>



// WEBPACK FOOTER //
// src/views/joinus/joinus.vue